import React from 'react';
import { css, Theme, useTheme } from "@emotion/react";

type Props = {
    children: React.ReactNode,
}

const InputWrapper = ({ children } : Props) => {
    const theme: Theme = useTheme();

    const styles = css`
        display: flex;
        width: 100%;
        justify-content: space-between;
        
        > div {
            position: relative;
            width: 280px;
            height: 100%;
            
            ${theme.breakpoints.only('sm')} {
                width: 232px;
            }

            ${theme.breakpoints.down('xs')} {
                width: 100%
            }
            
            :first-of-type {
                margin-right: 61px;
                
                ${theme.breakpoints.only('lg')} {
                    margin-right: 21px;
                }

                ${theme.breakpoints.only('md')} {
                    margin-right: 44px;
                }
                
                ${theme.breakpoints.only('sm')} {
                    margin-right: 30px;
                }
            }
        }
        
        ${theme.breakpoints.down('xs')} {
            flex-direction: column;
            margin-bottom: 19px;
        }
    `;

    return (
        <div css={styles}>
            {children}
        </div>
    )
};

export default InputWrapper;